(() => {
    function setupDonation(root) {
        if (root.dataset.donationReady) return;
        const form = root.querySelector('[data-sb-donation-form]');
        const variantSelect = root.querySelector('[data-donation-variant]');
        let data;
        try {
            data = JSON.parse(root.querySelector('[data-donation-data]').textContent);
        } catch {
            return;
        }
        if (!form || !variantSelect || !Array.isArray(data.variants)) return;
        root.dataset.donationReady = 'true';
        root.classList.add('sb-donation--ready');

        const recipient = root.querySelector('[data-donation-recipient]');
        const recipientFields = root.querySelector('[data-donation-recipient-fields]');
        const recipientProperty = root.querySelector('[data-donation-recipient-property]');
        const recognition = root.querySelector('[data-donation-recognition]');
        const recognitionFields = root.querySelector('[data-donation-recognition-fields]');
        const recognitionProperty = root.querySelector('[data-donation-recognition-property]');
        const submit = root.querySelector('[data-donation-submit]');
        const submitText = root.querySelector('[data-donation-submit-text]');
        const status = root.querySelector('[data-donation-status]');
        const media = Array.from(root.querySelectorAll('[data-donation-media]'));
        const thumbnails = Array.from(root.querySelectorAll('[data-donation-thumbnail]'));
        const recipientLabels = {
            'sustainable-books': 'Sustainable Books chooses',
            charity: 'Charity chosen by donor',
            school: 'School chosen by donor',
            daycare: 'Daycare chosen by donor',
            'after-school': 'After-school program chosen by donor',
            community: 'Community program chosen by donor'
        };
        let currentVariant;
        let activeImageIds = [];
        let submitting = false;

        function setFields(fieldset, enabled) {
            fieldset.hidden = !enabled;
            fieldset.disabled = !enabled;
        }

        function updateRecipient() {
            const canChoose = currentVariant?.size === 'Medium' || currentVariant?.size === 'Large';
            recipient.disabled = !canChoose;
            if (!canChoose) recipient.value = 'sustainable-books';
            const custom = canChoose && recipient.value !== 'sustainable-books';
            root.querySelector('[data-donation-recipient-choice]').hidden = !canChoose;
            root.querySelector('[data-donation-small-recipient]').hidden = canChoose;
            root.querySelector('[data-donation-default-help]').hidden = custom;
            setFields(recipientFields, custom);
            recipientProperty.value = recipientLabels[recipient.value] || recipientLabels['sustainable-books'];
        }

        function updateRecognition() {
            const named = recognition.value === 'named';
            setFields(recognitionFields, named);
            recognitionProperty.value = named ? 'Name donor to recipient' : 'Anonymous';
        }

        function showImage(id, announce) {
            if (!activeImageIds.includes(id)) return;
            media.forEach((figure) => {
                figure.hidden = figure.dataset.mediaId !== id;
            });
            thumbnails.forEach((button) => {
                button.setAttribute('aria-pressed', String(button.dataset.mediaId === id));
            });
            if (announce) {
                const figure = media.find((item) => item.dataset.mediaId === id);
                root.querySelector('[data-donation-gallery-status]').textContent =
                    `${currentVariant.size} package image ${activeImageIds.indexOf(id) + 1} of ${activeImageIds.length}: ${figure.dataset.mediaAlt}`;
            }
        }

        function updateGallery() {
            const normalizeId = (id) => String(id).split('/').pop();
            const supplied = data.imageGroups?.[currentVariant.size];
            const availableIds = new Set(media.map((figure) => figure.dataset.mediaId));
            activeImageIds = Array.isArray(supplied) ? supplied.map(normalizeId).filter((id) => availableIds.has(id)) : [];
            if (activeImageIds.length === 0) {
                const prefix = new RegExp(`^${currentVariant.size}\\s*(?:[-:|–—]|$)`, 'i');
                activeImageIds = media.filter((figure) => prefix.test(figure.dataset.mediaAlt)).map((figure) => figure.dataset.mediaId);
            }
            if (activeImageIds.length === 0 && availableIds.has(String(currentVariant.featuredMediaId))) {
                activeImageIds = [String(currentVariant.featuredMediaId)];
            }
            thumbnails.forEach((button) => {
                button.hidden = !activeImageIds.includes(button.dataset.mediaId);
            });
            if (activeImageIds.length > 0) showImage(activeImageIds[0], false);
            else media.forEach((figure) => {
                figure.hidden = true;
            });
            root.querySelector('[data-donation-gallery-status]').textContent = '';
        }

        function resetSubmission() {
            submitting = false;
            form.removeAttribute('aria-busy');
            submit.disabled = !currentVariant?.available;
            submitText.textContent = currentVariant?.available ? 'Add donation to cart' : 'Package unavailable';
            status.textContent = '';
        }

        function updateVariant(updateUrl) {
            if (submitting) {
                variantSelect.value = String(currentVariant.id);
                return;
            }
            currentVariant = data.variants.find((variant) => String(variant.id) === variantSelect.value);
            if (!currentVariant) {
                submit.disabled = true;
                status.textContent = 'Choose an available package.';
                return;
            }
            root.querySelector('[data-donation-price]').textContent = currentVariant.price;
            root.querySelectorAll('[data-donation-package]').forEach((panel) => {
                panel.hidden = panel.dataset.variantId !== String(currentVariant.id);
            });
            updateRecipient();
            updateGallery();
            resetSubmission();
            if (updateUrl) {
                const url = new URL(window.location.href);
                url.searchParams.set('variant', currentVariant.id);
                window.history.replaceState(window.history.state, '', url);
                status.textContent = `${currentVariant.size} package selected. Your contribution is ${currentVariant.price} per package.`;
            }
        }

        recipient.addEventListener('change', updateRecipient);
        recognition.disabled = false;
        recognition.addEventListener('change', updateRecognition);
        variantSelect.addEventListener('change', () => updateVariant(true));
        thumbnails.forEach((button) => {
            button.addEventListener('click', () => showImage(button.dataset.mediaId, true));
        });
        form.addEventListener('submit', (event) => {
            updateRecipient();
            updateRecognition();
            if (submitting || !currentVariant?.available || !form.reportValidity()) {
                event.preventDefault();
                return;
            }
            // Keep Shopify's localized native product POST as the only cart writer.
            submitting = true;
            form.setAttribute('aria-busy', 'true');
            submit.disabled = true;
            submitText.textContent = 'Adding donation…';
            status.textContent = 'Adding your donation to the cart.';
        });
        window.addEventListener('pageshow', () => {
            if (!root.isConnected) return;
            submitting = false;
            updateVariant(false);
            updateRecognition();
        });
        updateRecognition();
        updateVariant(false);
    }

    function start(scope = document) {
        if (scope.matches?.('[data-sb-donation]')) setupDonation(scope);
        scope.querySelectorAll('[data-sb-donation]').forEach(setupDonation);
    }

    document.addEventListener('shopify:section:load', (event) => start(event.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once: true});
    else start();
})();
